import { Alert, AlertColor, Box, Snackbar, SnackbarCloseReason, SnackbarOrigin } from '@mui/material';
import { useAppActions } from 'actions/app-actions';
import { SnackBarAlertType } from 'common/constants';
import { SnackbarType } from 'common/interfaces';
import { FC, useState } from 'react';
import { useAppSelector } from 'setup/store';

export interface SnackBarProps {}

const SnackBar: FC<SnackBarProps> = ({}) => {
  // const { vertical, horizontal, open } = state;

  const { resetSnackBar } = useAppActions();
  const snackBarStates = useAppSelector((state) => state.appReducer.snackBarStates);

  const handleClick = (newState: SnackbarOrigin) => () => {
    // setState({ ...newState, open: true });
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }

    resetSnackBar();
  };

  const getAlertSeverity = (type: SnackbarType | undefined): AlertColor => {
    switch (type) {
      case SnackbarType.ERROR:
        return 'error';
      case SnackbarType.WARNING:
        return 'warning';
      case SnackbarType.INFO:
        return 'info';
      case SnackbarType.SUCCESS:
        return 'success';
    }

    return 'info';
  };

  return (
    <>
      {snackBarStates ? (
        <Box sx={{ width: 500 }}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackBarStates.visible}
            autoHideDuration={snackBarStates.showTime}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={getAlertSeverity(snackBarStates.type)}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {snackBarStates.message}
            </Alert>
          </Snackbar>
        </Box>
      ) : null}
    </>
  );
};

export default SnackBar;
